import { Terms } from '~/enums'

export const useGetTermByWeek = (week: string) => {
  const weekPart = week.split('-')[1]
  const weekNumber = weekPart ? parseInt(weekPart, 10) : NaN
  if (weekNumber >= 36 && weekNumber <= 52) {
    return Terms.FIRST // Starts from October (weekNumber 36) to end December (weekNumber 52)
  } else if (weekNumber >= 1 && weekNumber <= 15) {
    return Terms.SECOND // January (weekNumber 1) to April (weekNumber 15)
  } else if (weekNumber >= 15 && weekNumber <= 36) {
    return Terms.THIRD // April (weekNumber 28) to July (weekNumber 36)
  } else {
    return Terms.THIRD // Ghana should not have a fourth term actually
  }
}

const getCurrentWeek = () => {
  const now = new Date()
  const startOfYear = new Date(now.getFullYear(), 0, 1)
  const pastDays = Math.floor(
    (now.getTime() - startOfYear.getTime()) / (24 * 60 * 60 * 1000),
  )
  return Math.ceil((pastDays + startOfYear.getDay() + 1) / 7) // Adjust for start of the year
}

export const useGetTerm = () => {
  // return Terms.SECOND
  const currentWeek = getCurrentWeek()
  const term = useGetTermByWeek(`week-${currentWeek}`)
  return term
}

export const useGetTermLabel = (term: Terms) => {
  switch (term) {
    case Terms.FIRST:
      return 'First Term'
    case Terms.SECOND:
      return 'Second Term'
    case Terms.THIRD:
      return 'Third Term'
    default:
      return term
  }
}
